module.exports = "/packs/media/images/icons/EliminateSubs_3-903b4888821483a18a9bcc08efd20d54.png";